import React from "react";
import { Table,Switch } from "antd";
import CircleIIcon from "../../../../../assets/circle_i.svg";
import { useSelector } from "react-redux";
import { removeAccountPrefixFromLabels } from "../../../../../../src/global/utility/Utils";
import ATSToolTip from "../../../../../global/components/ATSToolTip";

function ReviewLocations() {
   const { locations,nonshipsetalert,selectedDeviceProfile,profileType,locationList} = useSelector((state) => ({
    locations: state.deviceProfile.ui.form.fields.step3.locations || [],
    profileType: state.deviceProfile.ui.form.fields.step1.profileType || [],
    locationList: state.deviceProfile.data.locationList,
    nonshipsetalert: state.deviceProfile?.ui?.form?.fields?.nonshipstep3 ?? null,
    selectedDeviceProfile: Array.isArray(
      state.deviceProfile.ui.form.deviceTypes
    )
      ? state.deviceProfile.ui.form.deviceTypes.filter(
          (deviceType) =>
            deviceType.value ===
            state.deviceProfile.ui.form.fields.step1.deviceType.value
        )
    : [],
  }));
 
  let dataSource = [];
  
  if (Array.isArray(locations) && locations.length > 0) {
    dataSource = locations
      ?.filter((filteredLocation) => filteredLocation?.currentLocation !== "" )
      ?.map((location) => location[location.currentLocation])
      ?.filter((filteredLocation) => {
        const values = Object.values(filteredLocation);
        return values.some((val) => val?.value !== "");
      })
      ?.map((location, index) => ({
        key: `location-${index}`,
        shipping: location?.shipping?.value,
        //shipping: location,
        address: location?.address?.value,
        latitude: location?.latitude?.value,
        longitude: location?.longitude?.value,
        pointName: location?.pointName?.value,
        radius: location?.radius?.value,
        alerttype:location?.alerttype?.value!==undefined?location?.alerttype?.value?.charAt(0).toUpperCase() + location?.alerttype?.value?.slice(1):"Notification",
        trigger:location?.trigger?.value,
        alertgroup: Array.isArray(location?.alertgroup?.value)
          ? removeAccountPrefixFromLabels(location?.alertgroup?.value).join(", ")
          : removeAccountPrefixFromLabels(location?.alertgroup?.value) || "None",
      }));
  }
  const locationVal=locationList
  const zoneoutput = [];
  locationVal?.forEach(loc => {
    const locName = loc.name;
    if (loc.floors) {
      Object.values(loc.floors).forEach(floor => {
        const floorId = floor.id;
        const floorName = floor.name;
      if (floor.zones) {
          Object.values(floor.zones).forEach(zone => {
            zoneoutput.push({
              locationName: locName,
              floorId: floorId,
              floorName: floorName,
              zoneId: zone.id,
              zoneName: zone.zone_name
            });
          });
        }
      });
    }
  });
 function getZonePaths(zoneIds, output) {
  return zoneIds.map(zoneId => {
    const item = output.find(entry => entry.zoneId === zoneId);
    return item ? `${item.locationName} - ${item.floorName} - ${item.zoneName}` : null;
  }).filter(Boolean); // removes nulls if zoneId not found
}
 const model = selectedDeviceProfile?.[0]?.devicemodel?.toLowerCase();
  const columns = [
    {
      title: <span className="font-face-vzw">Shipping</span>,
      dataIndex: "shipping",
      key: "shipping",
       render: (_, record) => {
          return (
            <div className="d-flex flex-row justify-content-start align-items-center">
              <div>{record?.shipping}<br/>({record?.pointName})</div>
            </div>
          );
        },
    },
    {
      title: <span className="font-face-vzw">Address</span>,
      dataIndex: "address",
      key: "address",
    },
    {
      title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>
          Trigger
          <ATSToolTip text="Trigger alerts on">
            <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
          </ATSToolTip>
          </span>),
        dataIndex: "trigger",
        key: "trigger",
        width: 50,
        render: (text, record) => text === "entry and exit" ? <span>Both (Entry and exit)</span> : <span>{text}</span>,
      },
    {
      title: (
        <span className="font-face-vzw">
          Radius <ATSToolTip placement={"topRight"} text="Geofence radius in meters"><img src={CircleIIcon} className="mx-1" alt="info" /></ATSToolTip>
        </span>
      ),
      dataIndex: "radius",
      width: 100,
      key: "radius",
      render: (text) => (
       text ? `${text} m` : ""
      ),
    },
    {
        title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center"}}>
                    Alert Type
                    <ATSToolTip text="Severity level of the alarm">
                      <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
                    </ATSToolTip>
                  </span>),
          dataIndex: "alerttype",
          key: "alerttype",
          width: 130,
          onHeaderCell: () => ({
            "data-tooltip": "",
          }),
          render: (text, record) => <span>{text}</span>,
        },
         {
         title: (<span className="font-face-vzw" style={{ display: "flex", alignItems: "center", width:"130px"}}>
                     Alert Group
                     <ATSToolTip text="Alert groups to be notified of the alarm">
                       <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
                     </ATSToolTip>
                   </span>),
          dataIndex: "alertgroup",
          key: "alertgroup",
          width: 140,
          onHeaderCell: () => ({
            "data-tooltip": "",
          }),
          render: (text, record) => <span>{text}</span>,
        },
  ];
  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
       {profileType?.value === "nonshipment" && model === "gat" ? "Asset count":"Location"}
      </div>
      {profileType?.value === "shipment" ? (
      <Table
        className="review-table"
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
       ) : profileType?.value === "nonshipment" && model === "gat" ? (
      <>
    {nonshipsetalert?.nonshipsetalert === true && (
      <>
        <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
          {/* <div className="w-34 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
              Use case
            </span>
            <div
              className="txt-label"
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {nonshipsetalert?.nonshipusecase?.useCase?.value}
            </div>
          </div> */}

          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
              Asset threshold
            </span>
            <div className="txt-label">
              {nonshipsetalert?.inventoryMgmt?.assetthreshold?.value}
            </div>
          </div>

          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
              Asset type
            </span>
            <div className="txt-label">
              {Array.isArray(nonshipsetalert?.inventoryMgmt?.assettype?.value)
                  ? nonshipsetalert.inventoryMgmt.assettype.value.join(", ")
                  : nonshipsetalert?.inventoryMgmt?.assettype?.value}
            </div>
          </div>
        </div>

        <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
              Alert type
            </span>
            <div
              className="txt-label"
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {"Notification"}
            </div>
          </div>

          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
              Alert group
            </span>
            <div className="txt-label">
          { Array.isArray(nonshipsetalert?.inventoryMgmt?.alertgroup?.value)
          ? removeAccountPrefixFromLabels(nonshipsetalert?.inventoryMgmt?.alertgroup?.value).join(", ")
          : removeAccountPrefixFromLabels(nonshipsetalert?.inventoryMgmt?.alertgroup?.value) || "None"}
            </div>
          </div>
        </div>
      </>
        )}
        <div
          className="d-flex flex-row justify-content-start align-items-center"
          style={{
            padding: "8px 0px",
            margin: "24px 0px",
          }}
        >
          <div
            className="font-face-vzw"
            style={{
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            Alert
          </div>
          <div className="px-2">
            <Switch
              style={
                nonshipsetalert?.nonshipsetalert
                  ? { backgroundColor: "#008331" }
                  : { backgroundColor: "#d8dada" }
              }
              checked={nonshipsetalert?.nonshipsetalert}
              disabled={true}
            />
          </div>
        </div>
      </>
    ) : profileType?.value === "nonshipment" &&
       model === "ble"? (
       <>
       <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-start" style={{ alignItems: "flex-start" }}>
        <div className="w-50 d-flex flex-column justify-content-start align-items-start">
         <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
           Zone
          </span>
          {/* <div className="txt-label" style={{
           whiteSpace: "normal",
           wordBreak: "break-word",
           overflowWrap: "break-word",
          }}>{Array.isArray(nonshipsetalert?.nonshipbleloc?.locationzone?.value) &&
                getZonePaths(nonshipsetalert.nonshipbleloc.locationzone.value, zoneoutput).map((zonePath, idx) => (
                  <div key={idx}>{zonePath}</div>
                ))
              }</div> */}
              <div
              className="txt-label"
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {Array.isArray(nonshipsetalert?.nonshipbleloc?.locationzone?.value) &&
                nonshipsetalert.nonshipbleloc.locationzone.value.map((item, idx) => (
                  <div key={idx}>{item.label}</div> 
                ))}
            </div>
        </div>
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
             Trigger
          </span>
          <div className="txt-label">{nonshipsetalert?.nonshipbleloc?.trigger?.value}</div>
        </div>
      </div>
       <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-50 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Alert type
          </span>
          <div className="txt-label" style={{
           whiteSpace: "normal",
           wordBreak: "break-word",
           overflowWrap: "break-word",
          }}>{"Notification"}</div>
        </div>
          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
              Alert group
            </span>
            <div className="txt-label">
          {Array.isArray(nonshipsetalert?.nonshipbleloc?.alertgroup?.value)
          ? removeAccountPrefixFromLabels(nonshipsetalert?.nonshipbleloc?.alertgroup?.value).join(", ")
          : removeAccountPrefixFromLabels(nonshipsetalert?.nonshipbleloc?.alertgroup?.value) || "None"}
            </div>
          </div>
        </div>
         <div
          className="d-flex flex-row justify-content-start align-items-center"
          style={{
            padding: "8px 0px",
            margin: "24px 0px",
          }}
        >
          <div
            className="font-face-vzw"
            style={{
              fontWeight: 700,
              fontSize: "16px",
            }}
          >
            Alert
          </div>
          <div className="px-2">
            <Switch
              style={
                nonshipsetalert?.nonshipsetalert
                  ? {
                      backgroundColor: "#008331",
                    }
                  : {
                      backgroundColor: "#d8dada",
                    }
              }
              checked={nonshipsetalert?.nonshipsetalert}
              disabled={true}
            />
          </div>
        </div>
      </>
    ) : (
      ""
    )}
  </>
);
}

export default ReviewLocations;
